import React, { useEffect } from 'react'
import { isSafari } from 'react-device-detect'
import moment from 'moment'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { ReactComponent as TemplateEs } from './template_es.svg'
import { ReactComponent as TemplateEn } from './template_en.svg'
import { DEFAULT_LANGUAGE, LANGUAGES } from '../../../constants'

const Templates = {
    es: TemplateEs,
    en: TemplateEn,
}

const MainContainer = styled.div`
    width: ${({ width }) => width};
    box-shadow: ${() => (isSafari ? 'none' : '0px 8px 10px rgba(0,0,0,.25)')}
`
const spacedChars = (str) => str.split('').join(' ')

const Certificate = ({
    width,
    treesPlantedMonthly,
    nickname,
    id,
    date, // UNIX timestamp in miliseconds,
    language,
    treePluralTranslated,
}) => {

    const TemplateTag = Templates[language]

    let translateX = treesPlantedMonthly > 1
        ? 132
        : 118

    if (treesPlantedMonthly > 9) {
        translateX = 136
    }

    useEffect(() => {

        const dateObj = moment(date)

        // Hacky way of setting text dynamically within the SVG
        document.getElementById('nickname').innerHTML = nickname.toUpperCase()
        document.getElementById('treesPlantedMonthly').innerHTML = `${treesPlantedMonthly} ${treePluralTranslated}`
        // eslint-disable-next-line max-len
        document.getElementById('certificateDate').innerHTML = `0 1 . ${spacedChars(dateObj.format('MM'))} . ${spacedChars(dateObj.format('YYYY'))}`
        document.getElementById('certificateID').innerHTML = id

        if (language === LANGUAGES.es) {
            document.getElementById('treesPhrase').setAttribute('transform', `translate(${translateX}, 297)`)
        }

        if (isSafari) {
            document.querySelector('svg').style.boxShadow = '0px 4px 16px rgba(0,0,0,.25)'
        }

    }, [treesPlantedMonthly, nickname, id, date, language, translateX, treePluralTranslated])

    return (
        <MainContainer width={width}>
            <TemplateTag />
        </MainContainer>
    )
}

Certificate.propTypes = {
    width: PropTypes.string,
    treesPlantedMonthly: PropTypes.number,
    nickname: PropTypes.string,
    id: PropTypes.string,
    date: PropTypes.number,
    language: PropTypes.string,
    treePluralTranslated: PropTypes.string,
}

Certificate.defaultProps = {
    width: '100%',
    treesPlantedMonthly: 12,
    nickname: 'Treeman',
    id: '5f622d81e2e291bb18b24d1d',
    date: 1600275577000,
    language: DEFAULT_LANGUAGE,
    treePluralTranslated: 'tree',
}

export default Certificate
